type ImageDataToCanvasParams = {
  imageData: ImageData;
  destinationCanvas?: HTMLCanvasElement;
  targetWidth?: number;
  targetHeight?: number;
};

export const imageDataToCanvas = (params: ImageDataToCanvasParams) => {
  const { imageData, destinationCanvas, targetWidth, targetHeight } = params;

  const canvas = destinationCanvas ?? document.createElement('canvas');
  const ctx = canvas.getContext('2d')!;

  const aspectRatio = imageData.width / imageData.height;
  const aspectHeight = targetWidth ? targetWidth / aspectRatio : undefined;
  const aspectWidth = targetHeight ? targetHeight * aspectRatio : undefined;

  const canvasWidth = targetWidth ?? aspectWidth ?? imageData.width;
  const canvasHeight = targetHeight ?? aspectHeight ?? imageData.height;

  canvas.width = canvasWidth;
  canvas.height = canvasHeight;

  if (canvasWidth !== imageData.width || canvasHeight !== imageData.height) {
    const tempCanvas = document.createElement('canvas');
    const tempCtx = tempCanvas.getContext('2d')!;
    tempCanvas.width = imageData.width;
    tempCanvas.height = imageData.height;
    tempCtx.putImageData(imageData, 0, 0);
    ctx!.drawImage(tempCanvas, 0, 0, canvasWidth, canvasHeight);
  } else {
    ctx!.putImageData(imageData, 0, 0);
  }

  return canvas;
};
